var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-panel',_vm._b({attrs:{"padding":2}},'ui-panel',_vm.$attrs,false),[_c('div',{staticClass:"container"},[_c('ui-map',_vm._b({},'ui-map',_vm.$attrs,false),[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }